import React from 'react'
import WizardFormReduxConect from '../WizardFormReduxConect'
import { Modal, ModalBody, ModalHeader } from 'shards-react';

const ModalFormMyDealer = ({openState,openClose}) => {
  return (
    <Modal open={openState} size="lg">
    <ModalHeader>
      Completa los datos de tu Concesionaria
      <i
        style={{
          position: "absolute",
          right: "20px",
          top: "15px",
          fontSize: "25px",
          cursor: "pointer"
        }}
        class="material-icons"
        onClick={openClose}
      >
        clear
      </i>
    </ModalHeader>
    <ModalBody>
      <WizardFormReduxConect openClose={openClose} />
    </ModalBody>
  </Modal>
  )
}

export default ModalFormMyDealer
